/*
 * avaliacoes-google.js — carrossel das avaliações da home.
 *
 * Seletores de navegação ESCOPADOS (`.avaliacoes-prev` / `.avaliacoes-next`) em vez
 * dos `.swiper-button-prev` genéricos que as outras seções usam: a home tem três
 * carrosséis de produto além deste, e seletor global faz o Swiper pegar o PRIMEIRO
 * botão da página — as setas de um carrossel acabam controlando outro. As classes do
 * Swiper continuam no elemento só para herdar o estilo das setas.
 */
/*
 * MODO EMBUTIDO: puxa o selo para cima quando ele abre.
 *
 * O iframe do Google tem 64px fechado e cresce para ~600px ao abrir o detalhe,
 * desenhando o conteúdo lá pelo meio. Crescendo só para baixo, o popup nascia bem
 * abaixo do selo, com um vão grande no meio (relatado pelo Gilberto em 28/07/2026).
 * Aqui a gente devolve parte desse crescimento para cima, então o detalhe abre
 * praticamente sobre o selo — que é como popup se comporta em qualquer lugar.
 *
 * FATOR é quanto do crescimento vira subida. 1 jogaria o popup inteiro acima do selo
 * (some por cima dos cartões); 0 é o comportamento antigo. 0,6 deixa a maior parte
 * acima e a base perto do selo.
 *
 * Só no modo embutido: flutuando, o Google já ancora o popup sozinho e mexer estragaria.
 */
function ajustarSeloEmbutido() {
  var caixa = document.querySelector('.avaliacoes-selo');
  var selo = document.getElementById('cbv-gcr-badge');
  if (!caixa || !selo || typeof ResizeObserver === 'undefined') return;

  var FATOR = 0.6;
  var fechado = 0;

  new ResizeObserver(function (entradas) {
    var altura = Math.round(entradas[0].contentRect.height);
    if (!altura) return;
    // a primeira altura estável é a do selo fechado — serve de referência
    if (!fechado || altura < fechado) fechado = altura;
    var crescimento = Math.max(0, altura - fechado);
    var subida = Math.round(crescimento * FATOR);
    // o -20px horizontal vem do CSS e precisa ser repetido aqui, senão setar
    // `transform` no inline apaga o `translateX(calc(-50% - 20px))` e a pílula
    // pula para a direita justo quando o popup abre. Ver o comentário no CSS.
    selo.style.transform = 'translate(calc(-50% - 20px), -' + subida + 'px)';
  }).observe(selo);
}

document.addEventListener('DOMContentLoaded', function () {
  ajustarSeloEmbutido();
  if (typeof Swiper === 'undefined') return;
  var alvo = document.querySelector('[data-avaliacoes-carousel]');
  if (!alvo) return;

  // Autoplay some para quem pediu menos movimento no sistema. Texto que anda sozinho
  // é dos piores casos para quem tem sensibilidade a movimento — e a seção continua
  // navegável pelas setas e pelo arraste.
  var semMovimento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  new Swiper(alvo, {
    slidesPerView: 1.1,
    spaceBetween: 16,
    grabCursor: true,
    watchOverflow: true, // com poucas avaliações, esconde as setas em vez de travá-las
    navigation: {
      nextEl: '.avaliacoes-next',
      prevEl: '.avaliacoes-prev',
    },
    /*
     * `disableOnInteraction: true` — quem navegou assume o controle, e o carrossel
     * para de andar sozinho.
     *
     * ⚠️ ERA `false`, E ISSO IMPEDIA DE CHEGAR NA ÚLTIMA AVALIAÇÃO (relatado pelo
     * Gilberto em 14/08/2026, com nove avaliações na seção). O Swiper rebobina para
     * o começo ao chegar no fim — é o `stopOnLastSlide: false` que ele traz de
     * fábrica. Com o autoplay seguindo vivo durante a navegação manual, a pessoa
     * clicava na seta, e antes de alcançar o fim o autoplay a jogava de volta ao
     * primeiro cartão.
     *
     * Arrastar funcionava, e essa era a pista: as setas moram FORA do elemento do
     * carrossel, então o `pauseOnMouseEnter` protege quem arrasta (mouse por cima)
     * e não protege quem usa a seta (mouse ao lado).
     *
     * No celular era pior: as setas não existem, e `mouseenter` não acontece em
     * toque nenhum — logo, ninguém estava protegido. Arrastava até a última e seis
     * segundos depois voltava ao começo.
     *
     * `stopOnLastSlide` fica como está, de propósito: quem só olha continua vendo o
     * carrossel girar. O que não pode é ele girar por cima de quem está lendo.
     */
    autoplay: semMovimento
      ? false
      : { delay: 6000, disableOnInteraction: true, pauseOnMouseEnter: true },
    breakpoints: {
      768: { slidesPerView: 2, spaceBetween: 24 },
      992: { slidesPerView: 3, spaceBetween: 24 },
    },
  });
});
